import { render, staticRenderFns } from "./PriceClinic.vue?vue&type=template&id=2b605bae&"
import script from "./PriceClinic.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PriceClinic.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b605bae')) {
      api.createRecord('2b605bae', component.options)
    } else {
      api.reload('2b605bae', component.options)
    }
    module.hot.accept("./PriceClinic.vue?vue&type=template&id=2b605bae&", function () {
      api.rerender('2b605bae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorPriceBlockV2/components/PriceClinic.vue"
export default component.exports